import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { LandscapeContentBlocksOrganism } from '../../organisms';
import LandscapeStoryBaseEditTemplate from '../../../templates/LandscapeStoryBaseEditTemplate';
import { BlockItem } from '../../atoms/SortableImageBlockItem/SortableImageBlockItem';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';
export interface LandscapeContentBlocksTemplateProps {
  blockItems: BlockItem[];
  setBlockItems: (items: BlockItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const LandscapeContentBlocksTemplate: FC<
  LandscapeContentBlocksTemplateProps
> = ({
  blockItems,
  setBlockItems,
  changeOrderEnabled,
  setChangeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeStoryBaseEditTemplate>
          <LandscapeContentBlocksOrganism
            blockItems={blockItems}
            setBlockItems={setBlockItems}
            changeOrderEnabled={changeOrderEnabled}
            setChangeOrderEnabled={setChangeOrderEnabled}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        </LandscapeStoryBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeContentBlocksTemplate;
